module.exports = __webpack_public_path__ + "assets/img/add.523318e0.svg";